(() => {
  if (window.__bsAtcOverlayBound) return;
  window.__bsAtcOverlayBound = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-item__overlay-atc-button');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const count = parseInt(btn.getAttribute('data-variants-count') || '1', 10);
      if (count > 1) {
        const pid = btn.getAttribute('data-product-id');
        const overlay = document.querySelector('.bs-atc-overlay[data-product-id="' + pid + '"]');
        if (overlay) {
          overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        return;
      }
      addToCart(btn.getAttribute('data-variant-id'), btn);
      return;
    }

    const closeBtn = e.target.closest('[data-action="close"]');
    const overlayToClose = closeBtn && closeBtn.closest('.bs-atc-overlay');
    if (overlayToClose) {
      closeOverlay(overlayToClose);
      return;
    }

    const optBtn = e.target.closest('.bs-atc-overlay__option');
    if (optBtn && !optBtn.disabled) {
      const panel = optBtn.closest('.bs-atc-overlay__panel');
      if (!panel) return;
      panel.querySelectorAll('.bs-atc-overlay__option').forEach(function (o) {
        o.classList.remove('is-selected');
      });
      optBtn.classList.add('is-selected');
      const submit = panel.querySelector('.bs-atc-overlay__submit');
      if (submit) {
        submit.disabled = false;
        submit.setAttribute('data-variant-id', optBtn.getAttribute('data-variant-id'));
      }
      return;
    }

    const submitBtn = e.target.closest('.bs-atc-overlay__submit');
    if (submitBtn && !submitBtn.disabled) {
      const overlay = submitBtn.closest('.bs-atc-overlay');
      if (!overlay) return;
      addToCart(submitBtn.getAttribute('data-variant-id'), submitBtn, function () {
        closeOverlay(overlay);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const openOverlay = document.querySelector('.bs-atc-overlay.is-open');
    if (!openOverlay) return;
    closeOverlay(openOverlay);
  });

  function closeOverlay(overlay) {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    overlay.querySelectorAll('.bs-atc-overlay__option').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    const submit = overlay.querySelector('.bs-atc-overlay__submit');
    if (submit) {
      submit.disabled = true;
      submit.removeAttribute('data-variant-id');
    }
  }

  function addToCart(variantId, triggerEl, callback) {
    if (!variantId) return;
    const routes = window.themeVariables?.routes;
    if (!routes?.cartAddUrl || !routes?.cartUrl) {
      return;
    }
    triggerEl.disabled = true;
    fetch(routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }], sections: ['mini-cart'] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      })
      .then(function (data) {
        triggerEl.disabled = false;
        return fetch(routes.cartUrl + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('cart fetch failed');
            return r.json();
          })
          .then(function (cart) {
            cart.sections = data.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: true } })
            );
            if (callback) callback();
          });
      })
      .catch(function () {
        triggerEl.disabled = false;
      });
  }
})();
